module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "a-form-inputs"
  }, [_c('pre-accident-earnings', {
    on: {
      "update": _vm.updatePreAccidentEarnings
    }
  }), _vm._v(" "), (_vm.preAccidentEarnings && _vm.preAccidentEarningsValid && !_vm.ownPastLosses) ? _c('div', [_c('h2', {
    staticClass: "u-margin-bottom-40"
  }, [_vm._v("Post-accident Earnings")]), _vm._v(" "), _vm._l((_vm.getPostInjuryIncomePeriods), function(period, index) {
    return _c('post-accident-earnings', {
      attrs: {
        "index": index,
        "period": period,
        "maxIndex": _vm.getPostInjuryIncomePeriods.length
      }
    })
  }), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--small",
    on: {
      "click": function($event) {
        return _vm.addIncomePeriod('postInjury')
      }
    }
  }, [_vm._v("Add Period")])], 2) : _vm._e(), _vm._v(" "), (_vm.preAccidentEarnings && _vm.preAccidentEarningsValid && _vm.postInjuryIncomePeriodsValid && !_vm.ownPastLosses) ? _c('div', [_c('past-loss-of-earnings-calculator')], 1) : _vm._e(), _vm._v(" "), _c('step-button', {
    staticClass: "u-margin-top-40",
    attrs: {
      "next-valid": _vm.isValid
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3b2c046c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/personal-injury-claims/steps/PastLossOfEarnings.vue
// module id = 1647
// module chunks = 0